import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { CellEditArgs, DataSourceChangedEventArgs, DataStateChangeEventArgs, DetailRowService, GridComponent, GridModel, parentsUntil, QueryCellInfoEventArgs, SelectionService, SelectionSettingsModel, TextWrapSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { columnWidth } from '../employee/employee.model';
import { PurchaseVerificationlistService } from './purchase-verificationlist.service';
import { functionpermission, payerEmitBo, PurchaseVerficationReturnBO, PurchaseVListBO, timesheetVError } from './purchase-verification.model';
import { PurchaseVerificatioService } from './purchase-verification.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-purchase-verification',
  templateUrl: './purchase-verification.component.html',
  styleUrls: ['./purchase-verification.component.scss'],
  providers: [SelectionService, DetailRowService]

})

export class PurchaseVerificationComponent implements OnInit {
  public onDestroy$: Subject<void> = new Subject<void>();
  EmployeeListFilter: string;
  ClientListFilter: string;
  AllEmployeeList: any;
  AllClientList: any;
  fromDate: any;
  toDate: any;
  showerrolist: timesheetVError[] = [];
  showerrolistfilter: timesheetVError[] = [];
  isEnabled: boolean = false;
  result3: any = [];
  activeTab = "active";
  public dropdata: string[];
  public height = "220px";
  TimesheetGridList = new PurchaseVListBO();
  singledata:any=[];
  mulitpledata: PurchaseVerficationReturnBO[];
  Type: any;
  childData: any;
  errorlist: any;
  TimesheetVerficationList: any;
  ErrorNotesTimesheetV: string;
  @ViewChild("childtemplate") public childtemplate: any;
  @ViewChild("checkboxtemplate") public checkboxtemplate: any;
  @ViewChild("gridTimesheetV") public gridTimesheetV: GridComponent;
  public GridTimesheetVList: Observable<DataStateChangeEventArgs>;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public editSettings: object;
  public formatOptions: object;
  public filterOptions: object;
  public initialPage: object;
  public checkparams;
  public childGrid: GridModel;
  ClaimStatusList: any;
  claimStatusFilter: string;
  timesheetVList:any=[]
  public toolbar: ToolbarItems[];
  public selectionOptions: SelectionSettingsModel;
  public wrapSettings: TextWrapSettingsModel;
  ColumnArray: columnWidth[];
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate() + 1,
    },
    showClearDateBtn: true,
    editableDateField: true,
  };
  constructor(
    public dateservice: DateService,
    public global: GlobalComponent,
    public toastservice: ToastrService,
    public TimesheetVservice: PurchaseVerificatioService,
    public timesheetVListService: PurchaseVerificationlistService,
    public datepipe: DatePipe,
    private viewContainerRef?: ViewContainerRef
  ) {
    this.GridTimesheetVList = this.timesheetVListService;
  }
  fp:functionpermission=new functionpermission()
  ngOnInit(): void {
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") 
     {
      return;
    }
    this.toDate =
      new Date().getMonth() +
      1 +
      "/" +
      new Date().getDate() +
      "/" +
      new Date().getFullYear();
    this.fromDate =
      new Date().getMonth() +
      1 +
      "/" +
      new Date().getDate() +
      "/" +
      new Date().getFullYear();
    this.filterOptions = {
      type: "Menu",
    };
    this.selectionOptions = {
      checkboxOnly: true,
    };
    this.initialPage = {
      pageSizes: ["10", "20", "50", "100", "250"],
      pageSize: 10,
    };

    this.formatOptions = { type: "date", format: "MM/dd/yyyy" };
    // -----------for editsetup--------------

    this.toolbar = ["ColumnChooser"];
    this.checkparams = {
      checked: false,
    };
    this.wrapSettings = { wrapMode: "Content" };
    this.dropdata = ["Ready", "Validate", "OverUnits"];
    this.ClaimStatusList = [
      {
        Key: "Ready",
        Value: "Ready",
      },
      {
        Key: "Validate",
        Value: "Validate",
      },
      {
        Key: "OverUnits",
        Value: "OverUnits",
      },
    ];
    this.getClientDropDown();
    this.getEmployeesDropdown();
    this.getTimesheetVList();
this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "PurchseVerification");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.TimesheetVservice.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}

  //...................GetAllClientDropDown.............
  getClientDropDown() {
    this.TimesheetVservice.GetAllClientDropDown()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.AllClientList = data;
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }

  //................GetAllEmployeesDropdown.............
  getEmployeesDropdown() {
    this.TimesheetVservice.GetAllEmployeesDropdown()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.AllEmployeeList = data;
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }

  //----showTimesheetColumns-----//
  showTimesheetColumns() {
    this.gridTimesheetV.openColumnChooser(200, 50);
  }

  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == "FromDate") {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let datevalue = this.dateservice.inputFeildchangeReturnall(event);
          this.fromDate = datevalue;
        }
      }
      if (name == "ToDate") {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let datevalue = this.dateservice.inputFeildchangeReturnall(event);
          this.toDate = datevalue;
        }
      }
    }
    if (type == "datechanged") {
      if (name == "FromDate") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let datevalue = this.dateservice.Datechange(event);
          this.fromDate = datevalue;
        }
      }
    }
    if (name == "ToDate") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let datevalue = this.dateservice.Datechange(event);
        this.toDate = datevalue;
      }
    }
  }

  getTimesheetVList() {
    if (this.global.checkProgressPurchase == true) {
      this.toastservice.error("Billing is inProgress!");
      return;
    }
    this.errorlist = [];
    this.emitpayer.TimsheetV_payer = false;
    this.TimesheetGridList.agencyId = this.global.globalAgencyId;
    this.TimesheetGridList.requesttype = "aaa";
    // this.TimesheetGridList.locationId = this.global.selectedLocationDropdown;
    // this.TimesheetGridList.timesheetType = "aaa";
    this.TimesheetGridList.fromDate = this.global.getDateTimeString(this.fromDate)
    this.TimesheetGridList.toDate = this.global.getDateTimeString(this.toDate)

    this.timesheetVListService.execute(this.TimesheetGridList);
    this.GridTimesheetVList.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        this.timesheetVList=this.timesheetVListService.gettimesheetVerifyList();

        this.errorlist = [];
        this.errorlist = this.timesheetVListService.getErrorlist();
        
        this.TimesheetVerficationList =
          this.timesheetVListService.getAllTimeshettList();
        this.ErrorNotesTimesheetV = this.timesheetVListService.getErrorNotes();
      }
    );
  }
  filterApply() {
    this.TimesheetGridList.fromDate = this.fromDate;
    this.TimesheetGridList.toDate = this.toDate;
    this.TimesheetGridList.fromDate =
      this.TimesheetGridList.fromDate != null &&
      this.TimesheetGridList.fromDate != undefined &&
      this.TimesheetGridList.fromDate != ""
        ? this.global.getDateTimeString(this.TimesheetGridList.fromDate)
        : null;
    this.TimesheetGridList.toDate =
      this.TimesheetGridList.toDate != null &&
      this.TimesheetGridList.toDate != undefined &&
      this.TimesheetGridList.toDate != ""
        ? this.global.getDateTimeString(this.TimesheetGridList.toDate)
        : null;

    this.getTimesheetVList();
  }

  Refresh() {
    this.TimesheetGridList.fromDate = this.global.getDateTimeString(new Date());
    this.TimesheetGridList.toDate = this.global.getDateTimeString(new Date());
    this.toDate =
      new Date().getMonth() +
      1 +
      "/" +
      new Date().getDate() +
      "/" +
      new Date().getFullYear();
    this.fromDate =
      new Date().getMonth() +
      1 +
      "/" +
      new Date().getDate() +
      "/" +
      new Date().getFullYear();
    // this.TimesheetGridList.employeeid = null;
    this.TimesheetGridList.clientId = null;
    this.getTimesheetVList();
  }

  getActiveTab(TabChange) {
    this.activeTab = TabChange;

    if (this.activeTab == "active") {
    }
    if (this.activeTab == "archive") {
    }
  }
  cellEdit(args: CellEditArgs) {
    if (args.value === "Ready") {
      args.cancel = true;
    }
  }
  public dataSourceChanged(state: DataSourceChangedEventArgs): void {
    if (state.action === "edit") {
      state.endEdit();
    }
  }

  getdata(args) {
    alert("toolbar");
    if (args.data["bit"] > 0) {
      args.row
        .getElementsByClassName("e-gridchkbox")[0]
        .classList.add("disablecheckbox");
      args.row
        .getElementsByClassName("e-checkbox-wrapper")[0]
        .classList.add("disablecheckbox");
    }
    var grid = parentsUntil(args.target, "e-grid") as any;

    this.result3 = grid.ej2_instances[0].getRowInfo(args.target).rowData;
  }

  startDateauth: any;
  endDateauth: any;
  clientauthId: string;
  PayerId: string;
  showerrors(args) {
    this.isEnabled = false;
    this.showerrolist = [];
    this.showerrolistfilter = [];
    var grid = parentsUntil(args.target, "e-grid") as any;
    this.result3 = grid.ej2_instances[0].getRowInfo(args.target).rowData;
    this.startDateauth = this.result3.fromDate;
    this.endDateauth = this.result3.toDate;
    let purchaseRequestId = this.result3.purchaseRequestId;

    this.errorlist.forEach((element) => {
      if (element.purchaseRequestId == purchaseRequestId) {
        this.showerrolist.push(element);
        JSON.parse(JSON.stringify(this.showerrolistfilter.push(element)));
      }
    });
    this.showerrolist.forEach((element) => {
      this.clientauthId = element.clientauthId;
      // this.PayerId = element.groupPayorId;
    });
    
  }

  colseerr() {
    document.getElementById("OpenModal2").click();
  }

  SelectErrorData() {
    this.global.loading = false;
    if (this.isEnabled == true) {
      this.showerrolist = this.showerrolistfilter.filter(
        (s) => s.isValid == false
      );
    } else {
      this.showerrolist = this.showerrolistfilter;
    }
  }

  // rowDataBound1(args) {
  //   if (args.data["bit"] > 0) {
  //     args.row.style.color = "White";
  //     args.row.height = "20";
  //   }
  // }

  validatebutton(args: QueryCellInfoEventArgs) {
    if (args.column.field == "validate") {
      if (args.data["buttoncolor"] == "red") {
        args.cell.firstElementChild.firstElementChild.innerHTML = "Validate";
        args.cell.firstElementChild.firstElementChild.classList.add("btn_colorRed");
      }
      if (args.data["buttoncolor"] == "green") {
        args.cell.firstElementChild.firstElementChild.innerHTML = "Ready";
        args.cell.firstElementChild.firstElementChild.classList.add("btn_color");
      }
    }
  }
  public selIndex: any[] = [];
  
  
  documentType: string = "";
  public dataStateChange(state): void {
    this.documentType = state.action.requestType.toString();

    if (this.documentType != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.TimesheetGridList.orderColumn = state.sorted[0].name;
        this.TimesheetGridList.orderType =
          state.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (
      this.documentType == "filtering" &&
      state.action.action != "clearFilter"
    ) {
      this.TimesheetGridList.field = state.action.currentFilterObject.field;
      this.TimesheetGridList.matchCase =
        state.action.currentFilterObject.matchCase;
      this.TimesheetGridList.operator =
        state.action.currentFilterObject.operator;
      this.TimesheetGridList.value = state.action.currentFilterObject.value;
    } else {
      if (
        this.documentType == "filtering" &&
        state.action.action == "clearFilter"
      ) {
        this.TimesheetGridList.field = "claimStatus";
        this.TimesheetGridList.matchCase = false;
        this.TimesheetGridList.operator = "startswith";
        this.TimesheetGridList.value = "";
        this.TimesheetGridList.type = "string";
      }
    }
    if (this.documentType != "refresh") {
      this.getTimesheetVList();
    }
  }

  rowDataBound(args) {

    if (args.data['claimStatus'] == 'Validate') {

      args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox');

      args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox')

    }
  

    this.TimesheetVerficationList?.forEach((element) => {
      if (args.data["purchaseRequestId"] == element) {
        args.rowHeight = "25";
        this.selIndex.push(
          parseInt(args.row.getAttribute("aria-rowindex"), 10)
        );
      }
    });

    if (args.data["bit"] > 0) {
      args.rowHeight = "25";
      args.row
        .getElementsByClassName("e-gridchkbox")[0]
        .classList.add("disablecheckbox");
      args.row
        .getElementsByClassName("e-checkbox-wrapper")[0]
        .classList.add("disablecheckbox");
    }
  }

  public onActionComplete(G) {
    this.TimesheetGridList.currentpageno =
      this.gridTimesheetV.pagerModule.pagerObj.currentPage;
    this.TimesheetGridList.pageitem =
      this.gridTimesheetV.pagerModule.pagerObj.pageSize;
    if (G.name == "actionBegin" && G.requestType == "filterbeforeopen") {
      this.TimesheetGridList.type = G.columnType;
    }
  }

  onResize(args) {
    const column = this.gridTimesheetV.getColumnByField(args.column.field);
    column.width = args.column.width;
    this.gridTimesheetV.refreshHeader();
    this.ColumnArray?.forEach((element) => {
      if (element.column == column.headerText) {
        element.width = parseInt(column.width.toString());
      }
    });
  }

  selecteddata:any=[] 
  CheckBoxClickEvent(args) {
    var customselect = [];
    this.selecteddata = [];
    if (args.checked && args.target.classList.contains("e-checkselectall")) {
      for (var i = 0; i < args.selectedRowIndexes.length; i++) {

        var row = this.gridTimesheetV.getRowByIndex(args.selectedRowIndexes[i]);

        if (!row.querySelector('.disablecheckbox')) {
          this.selecteddata = []
          customselect.push(args.selectedRowIndexes[i])


        }

      }
      this.gridTimesheetV.selectRows(customselect)
      this.timesheetVList.forEach((e, index) => {
        customselect.forEach(element => {
          if (element == index) {

            this.selecteddata.push(e);
          }
        })

      })
    }
    else if (args.target.classList.contains("e-checkselect")) { 
      let rowsdata: any = this.gridTimesheetV.getSelectedRecords();
      let list = rowsdata.map(d => d.purchaseRequestId)
      this.timesheetVList.forEach((e) => {
        list?.forEach(id => {
          if (e.purchaseRequestId == id) 
          {
            this.selecteddata.push(e);
        

          }      
      })
    })
     
    }
 
  }
  selecttobill() {
    this.global.checkidlePurchase = true;
    this.global.checkProgressPurchase = null;
    if(this.global.checkProgressTimesheet==false){
      this.global.checkProgressTimesheet=null
    }
    else if(this.global.checkProgressTransaction==false){
      this.global.checkProgressTransaction=null
    }
   

     if (this.selecteddata.length != 0) {
      this.TimesheetVservice.Selectbill(this.selecteddata)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((data: any) => {
          // this.toastservice.success("Selected Record submited successfully!");
          this.selecteddata = [];
          this.singledata = [];
          this.mulitpledata = [];
          this.global.scheduleClaimProgressForPurchase(data.progressId)
          this.getTimesheetVList();
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err), 8000;
          }
        }
        );
    }
  }
  // claimStatusFilterfun() {
  //   this.TimesheetGridList.status = this.claimStatusFilter;
  //   this.getTimesheetVList();
  // }

  emitpayer: payerEmitBo = new payerEmitBo();
  timetoClientemit = false;
  abc(column, color) {
    if (
      (column == "payorName" ||
        column == "Payor_AddressLine1" ||
        column == "Payor_AddressLine2" ||
        column == "Payor_ClaimFilingIndicatorCode" ||
        column == "Payor_City" ||
        column == "Payor_State" ||
        column == "Payor_Zip" ||
        column == "PayorID" ||
        column == "I837PInsType" ||
        column == "Payor_PhoneNumber" ||
        column == "Payor_Atypical" ||
        column == "PayorCompany_ProviderNo" ||
        column == "PayorCompany_Taxonomycode") &&
      color == "red"
    ) {
      document.getElementById("OpenModapayer").click();
      this.emitpayer.TimsheetV_payer = true;
      this.emitpayer.payerId = this.PayerId;
    }
  }
}
